<template>
  <div>
    <br><span>Produto: {{ orderItem.product && orderItem.product.description }}</span>
    <br><span>Marca: {{ orderItem.product && orderItem.product.brand }}</span>
    <br><span>Quantidade: {{ orderItem.quantity }}</span>
    <br><span>Data de emissão do pedido: {{ orderItem.created_at | humanDateTime }}</span>
    <br><span>Tabela de Preço: {{ orderItem.price_table && orderItem.price_table.description }}</span>
    <br><span v-show="orderItem.payment_condition">Condição: {{ orderItem.payment_condition && orderItem.payment_condition.name }}</span>
    <br><span>Valor da venda: {{ saleValue.toLocaleString("pt-BR", { style: "currency", currency: "brl" }) | currency }}</span>
    <br><span>Valor permitido: {{ permitedValue | currency }}</span>
    <br><span>Valor informado: {{ informedValue | currency }}</span>
    <div v-if="informedValue < permitedValue" style="margin-top: -25px; margin-bottom: -25px;">
      <br><span >Valor excedido: {{ exceededValue | currency }}</span>
    </div>
    <br><span>Valor na tabela: {{ orderItem.value_in_table | currency }}</span>
    <br><span>Desconto comercial: {{ orderItem.discount_percentage | number }} %</span>
    <br><span>Desconto máximo permitido: {{ orderItem.max_discount | number }} %</span>
    <hr>
  </div>
</template>

<script>
export default {
  name: 'order-item-details',
  props: {
    orderItem: Object
  },
  computed: {
    exceededValue() {
      const informedValue = (((100 - this.orderItem.discount_percentage || 0) / 100) * (this.orderItem.unit_value || 0))
      const permitedValue = (((100 - this.orderItem.max_discount || 0) / 100) * (this.orderItem.value_in_table || 0))
      let exceededValue = 0;

      if (informedValue < permitedValue) {
        exceededValue = informedValue - permitedValue;
      }

      return exceededValue.toLocaleString("pt-BR", { style: "currency", currency: "brl" });
    },
    informedValue() {
      return (((100 - this.orderItem.discount_percentage || 0) / 100) * (this.orderItem.unit_value || 0)).toLocaleString("pt-BR", { style: "currency", currency: "brl" })
    },
    permitedValue() {
      return (((100 - this.orderItem.max_discount || 0) / 100) * (this.orderItem.value_in_table || 0)).toLocaleString("pt-BR", { style: "currency", currency: "brl" })
    },
    saleValue() {
      return (this.orderItem.unit_value || 0).toLocaleString("pt-BR", { style: "currency", currency: "brl" })
    }
  }
}
</script>

<style>

</style>